import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=bc56b2b4"
import script from "./CaseForm.vue?vue&type=script&lang=js"
export * from "./CaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports